import React from 'react'
import './Contacto.css'
import Header from '../Header/Header'
import ContactoData from '../../components/Admin/ContactoData/ContactoData'
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash'
export default function Contacto() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <ContactoData />
                </div>
            </section>
        </div>
    )
}

